import { createConsumer } from '@rails/actioncable';

export const consumer = createConsumer('/cable');
